import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import FacetPlanAddExpense from 'Views/Page/Content/Modal/Layouts/FacetPlanAddExpense';

const AddFacetPlanExpenseStep = () => {
  const { setModalCollection } = useModalContext();

  const onSubmit = async (res) => {
    setModalCollection(res);
  };

  return (
    <FacetPlanAddExpense onSubmit={onSubmit} />
  );
};

AddFacetPlanExpenseStep.defaultProps = {
};

AddFacetPlanExpenseStep.propTypes = {
};

export default AddFacetPlanExpenseStep;
